import { render, staticRenderFns } from "./PkgRiskList.vue?vue&type=template&id=19a79426&"
import script from "./PkgRiskList.vue?vue&type=script&lang=js&"
export * from "./PkgRiskList.vue?vue&type=script&lang=js&"
import style0 from "./PkgRiskList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgRiskList.vue"
export default component.exports